import React from "react";
import { useHistory } from "react-router-dom";
import OTLayout from "./OTLayout";
import { OT_BASE, WORKFLOW_CATEGORIES, C } from "./constants";
import { WORKFLOWS } from "./workflows";
import {
  OtPage,
  SectionCard,
  Box,
  Grid,
  Typography,
  Stack,
  OtCardButton,
  eyebrowSx,
  titleSx,
  subtitleSx,
} from "./ui";

export default function OTWorkflows() {
  const history = useHistory();

  return (
    <OTLayout activeNav="workflows">
      <OtPage>
        <Typography sx={eyebrowSx}>Library</Typography>
        <Typography component="h1" sx={titleSx}>Operation Theatre workflows</Typography>
        <Typography sx={{ ...subtitleSx, maxWidth: 640, mb: 3 }}>
          The 12 standard pathways that govern every case — scheduling, assessment, intra-operative care and support processes.
        </Typography>

        {WORKFLOW_CATEGORIES.map((cat) => {
          const items = WORKFLOWS.filter((w) => w.category === cat);
          return (
            <Box component="section" key={cat} sx={{ mb: 3.5 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 1.5 }}>
                <Typography component="h2" sx={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: C.textSub }}>
                  {cat}
                </Typography>
                <Typography sx={{ fontSize: 12, color: C.textSub }}>{items.length} workflows</Typography>
              </Stack>
              <Grid container spacing={1.5}>
                {items.map((w) => (
                  <Grid item xs={12} md={6} lg={4} key={w.slug}>
                    <SectionCard sx={{ p: 2.5 }}>
                      <OtCardButton
                        onClick={() => history.push(`${OT_BASE}/workflows/${w.slug}`)}
                        sx={{ p: 0, border: "none", "&:hover": { border: "none" } }}
                      >
                        <Stack direction="row" justifyContent="space-between" sx={{ width: "100%", fontSize: 11 }}>
                          <Typography sx={{ fontFamily: "monospace", color: C.textSub, fontSize: 11 }}>{w.code}</Typography>
                          <Typography sx={{ color: C.textSub, fontSize: 11 }}>§ {w.number}</Typography>
                        </Stack>
                        <Typography sx={{ mt: 1.25, fontSize: 16, fontWeight: 700, color: C.text, textAlign: "left" }}>{w.title}</Typography>
                        <Typography sx={{ mt: 1, fontSize: 13, color: C.textSub, lineHeight: 1.45, textAlign: "left" }}>{w.summary}</Typography>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 1.75, pt: 1.5, borderTop: `1px solid ${C.border}`, width: "100%" }}>
                          <Typography sx={{ fontSize: 12, color: C.textSub }}>{w.steps.length} stages</Typography>
                          <Typography sx={{ fontSize: 12, color: C.primary, fontWeight: 600 }}>Open →</Typography>
                        </Stack>
                      </OtCardButton>
                    </SectionCard>
                  </Grid>
                ))}
              </Grid>
            </Box>
          );
        })}
      </OtPage>
    </OTLayout>
  );
}
